<div
  class="container"
  [ngClass]="{ 'seperator-border': hasSeperator, 'final-val': !hasSeperator }"
>
  @if (title !== null) {
    <ion-label class="label">{{ title }}</ion-label>
  }
  <ion-row>
    @for (col of data; track col) {
      <ion-col
        size="4"
        class="item"
        [ngClass]="{ 'final-item-val': !hasSeperator }"
      >
        <ion-label class="title">{{ col.label }}:</ion-label>
        <ion-text class="details">{{ col.value }}</ion-text>
      </ion-col>
    }
  </ion-row>
</div>
